// The seller's own brand terms. Never blocked, never suggested as a target.
//
// Editable because both mistakes cost something: a brand missed here lets this
// feature block the seller's own name, and a word wrongly listed here stops a
// real negative from ever being raised.
import React, { useState } from 'react';
import s from '../KeywordOptimiser.module.css';

export default function Brands({ brands, onSave, busy }) {
  const [adding, setAdding] = useState('');
  if (!brands) return <p className={s.empty}>Loading…</p>;
  return (
    <div>
      <p className={s.coverage}>
        Detected from {brands.source}. Nothing on this list is ever blocked as a
        negative, and nothing on it is offered as a keyword to target — your own brand
        is already yours.
      </p>
      <div className={s.brandRow}>
        {(brands.tokens || []).map((token) => (
          <span key={token} className={s.wordChip}>
            {token}
            <button className={s.chipRemove} disabled={busy}
                    onClick={() => onSave({ remove: [token] })}
                    aria-label={`remove ${token}`}>×</button>
          </span>
        ))}
        {!(brands.tokens || []).length && (
          <span className={s.thin}>
            Nothing detected. Without at least one brand term, this feature could
            suggest blocking a search for your own name — add it here.
          </span>
        )}
      </div>
      <div className={s.discoverBar} style={{ marginTop: 14 }}>
        <label className={s.field} style={{ flex: '1 1 200px' }}>
          <span className={s.label}>Add a brand term</span>
          <input className={s.asinInput} value={adding}
                 onChange={(e) => setAdding(e.target.value)} />
        </label>
        <button className={s.button} disabled={busy || !adding.trim()}
                onClick={() => { onSave({ add: [adding.trim()] }); setAdding(''); }}>
          Add
        </button>
      </div>
      {!!(brands.removed || []).length && (
        <p className={s.coverage}>
          Removed by you: {brands.removed.join(', ')}. These are treated as ordinary
          words again.
        </p>
      )}
    </div>
  );
}
